<template>
    <main class="layout__main--narrow layout__main--no-top-padding">
        <article
            v-if="!error"
            class="bleed"
        >
            <BaseSection
                v-if="!pending && page"
                class="container-narrow"
            >
                <template #title>
                    <h1>{{ page.title }}</h1>
                </template>

                <!-- eslint-disable vue/no-v-html -->
                <div
                    v-if="page.introText"
                    class="lead"
                    data-allow-anchor
                    v-html="page.introText"
                />
                <!-- eslint-enable vue/no-v-html -->

                <!-- <press-releases-meta :press-releases="page" /> -->
                <BasePillsList :pills="pills(page, event)" />
            </BaseSection>

            <BaseSection
                v-else-if="pending"
                class="container-narrow"
            >
                <template #title>
                    <h1>
                        <ContentPlaceholdersHeading :lines="2" />
                    </h1>
                </template>

                <p class="lead">
                    <ContentPlaceholdersText :lines="5" />
                </p>
                <div class="press-releases-meta">
                    <ContentPlaceholdersText :lines="1" />
                </div>
                <div class="page__pills">
                    <ContentPlaceholdersText :lines="1" />
                </div>
            </BaseSection>

            <flexibleSections
                :sections="page ? page.sections : []"
                :placeholder="pending ? 'content' : undefined"
            />

            <BaseSection
                v-if="page"
                class="container-narrow"
            >
                <LazyBaseSocialLinks
                    type="article"
                    :hydrate-on-visible
                />
            </BaseSection>
        </article>
    </main>
</template>

<script setup>
import DetailQuery from '~/graphql/queries/PressReleases/detail.graphql';

const { activeSite } = useMultisite();
const { pills } = usePillsPage();
const { variables } = useCraftVariables();
const route = useRoute();

const response = await useLazyAsyncQuery({
    query: DetailQuery,
    variables: {
        ...toValue(variables),
        slug: route.params.slug
    }
});

const {
    craftEntry: page,
    pending,
} = usePageQuery(
    response,
    { entryKey: 'page', activeSite }
);
</script>
